<style scoped>
.contet_title {
  font-size: 22px;
  padding-top: 25px;
  padding-bottom: 20px;
  text-align: center;
  font-weight: bold;
}
.content--box {
  padding: 15px;
  box-sizing: border-box;
}
</style>

<template>
  <div>
    <div class="contet_title">
      {{ title }}
    </div>
    <div class="content--box">
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p
        style="text-align: right; text-indent: 2em"
        class="MsoNormal"
        align="right"
      >
        <span style="color: #000000">协议版本：【2.0】</span>
      </p>
      <p
        style="text-align: right; text-indent: 2em"
        class="MsoNormal"
        align="right"
      >
        <span style="color: #000000"
          >发布/生效日期：【<u>2018年12月6日</u>发布，自发布之日起7日后生效】</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000">欢迎您使用美滋来外卖的各项服务！</span>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >您在使用美滋来外卖服务前，应当仔细认真阅读本《美滋来外卖用户服务条款》(下称“<strong>本条款</strong>”，</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >中的全部规则、《美滋来外卖平台用户服务协议》（以下简称“《<strong>美滋来外卖平台用户服务协议</strong>》”）及美滋来外卖发布的其他服务条款、专项产品或服务规则或规范（包括但不限于《美滋来外卖代金券使用规则》、《美滋来外卖红包使用规则》、《美滋来外卖用户评价规则》以及其他在美滋来外卖平台不时发布的服务规则或规范等，以下合称“<strong>服务规则</strong>”）的内容（<strong>特别是其中以黑体字标示出的关于美滋来外卖及用户重大权益的规则，该等规则可能涉及相关方的责任免除或限制、法律适用与争议解决条款，请您重点阅读</strong>），确认对本条款、《美滋来外卖平台用户服务协议》及各项服务规则均已知晓、理解并接受，并已同意将其作为确定双方权利义务的依据。<strong
            ><u
              >如您使用美滋来外卖账号访问美滋来外卖服务或以其他方式使用或接受美滋来外卖的任何服务，即视为您已阅读并与美滋来外卖达成协议，自愿接受本条款的所有内容的约束。所有服务规则视为本条款不可分割的一部分，与本条款具有同等法律效力。</u
            ></strong
          ></span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          ><span style="font-size: 11ptpx"
            >本条款的签约双方为美滋来外卖平台服务的实际运营商新疆淘乐梦电子商务有限公司与使用美滋来外卖相关服务的使用人（下称“<strong>用户</strong>”或“<strong>您</strong>”），本条款是您与美滋来外卖之间关于您使用美滋来外卖平台提供的各项服务所订立的服务条款，具有正式书面合同的效力。</span
          ></span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >本条款为《美滋来外卖平台用户服务协议》（包括但不限于所附的《美滋来外卖平台隐私政策》）的必要组成部分。《<strong
            ><u>美滋来外卖平台用户服务协议</u></strong
          >》<strong
            ><u
              >将同时适用于美滋来外卖的各项服务。如本条款与《美滋来外卖平台用户服务协议》文本内容存在冲突之处，则以时间上最新发布的内容为准，发布时间相同的，以本条款为准。本条款有待明确、存在歧义或未规定之处均以《美滋来外卖平台用户服务协议》中的规定为准。</u
            ></strong
          ></span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <strong
          ><u
            ><span style="color: #000000"
              >您理解并同意，美滋来外卖将根据《美滋来外卖平台用户服务协议》的约定，对本条款或各项服务规则不时地进行修改更新。修改更新内容的发布和实施均适用《美滋来外卖平台用户服务协议》的相关约定。</span
            ></u
          ></strong
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: left; text-indent: 2em" class="MsoNormal">
        <strong><span style="color: #000000">一、&nbsp;定义</span></strong>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >1.1&nbsp;美滋来外卖：指美滋来外卖旗下的网上订餐平台，包括但不限于美滋来网外卖频道（https://mulazim.com，或依美滋来外卖根据业务需要修改的URL）、美滋来客户端外卖频道、美滋来外卖客户端、美滋来网上订餐服务相关的其他平台及/或客户端等。</span
        >
      </p>
      <p style="text-align: left; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >1.2商家：指入驻美滋来外卖并通过美滋来外卖向用户提供各类商品/服务订购的第三方商家。</span
        >
      </p>
      <p style="text-align: left; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >1.3&nbsp;客户端：指包含Windows、IOS、安卓及已有或未来新增的任何桌面平台或移动平台的美滋来外卖客户端的单称或合称。</span
        >
      </p>
      <p style="text-align: left; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >1.4外卖交易：指用户通过美滋来外卖进行的商品/服务的交易活动，包括但不限于订餐交易，即对餐饮商家、超市百货商家在内的美滋来外卖上入驻的第三方商家所提供的各类食品、日用品等餐品或商品/服务的订购。</span
        >
      </p>
      <p style="text-align: left; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >1.5外卖信息：指商家通过美滋来外卖发布的、在美滋来外卖页面上展示的商品/服务信息，包括但不限于商品/服务的名称、种类、数量、质量、价格、有效期、预计送达时间、商户地址、配送方式、退换货方式、退款条件、售后服务等内容。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: left; text-indent: 2em" class="MsoNormal">
        <strong><span style="color: #000000">二、&nbsp;用户账号</span></strong>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >2.1您知悉并同意，您可通过注册新的美滋来外卖账号或登录您现有的美滋来外卖账号以使用美滋来外卖的各项服务及功能，并应遵守《美滋来外卖平台用户服务协议》中的各项规定。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: left; text-indent: 2em" class="MsoNormal">
        <strong><span style="color: #000000">三、&nbsp;平台服务</span></strong>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000">3.1美滋来外卖将向您提供如下服务：</span>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >3.1.1美滋来外卖维护美滋来外卖平台的正常运行，积极改进技术，提升您在外卖交易时的服务体验。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >3.1.2美滋来外卖对您就平台服务、交易安全等相关问题所反映的客观情况和建设性建议，进行积极研究并予以改进。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >3.1.3美滋来外卖在您与商家或其他用户之间产生争议时，在法律要求的范围内协助进行协商调解，并在您或商家通过司法或执法机关要求美滋来外卖提供相关资料时，予以积极配合。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >3.1.4其他在本条款及《美滋来外卖平台用户服务协议》项下约定的服务，或美滋来外卖所不时推出的新功能或新服务。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >3.2&nbsp;您可根据本条款、《美滋来外卖平台用户服务协议》及美滋来外卖不时公布的服务规则，使用您的美滋来外卖账号查阅在美滋来外卖平台上发布的外卖信息、通过美滋来外卖订餐、发布商品/服务评价信息、邀请关注好友、使用美滋来外卖的其他服务（如跑腿代购等）以及美滋来外卖现有及将来可能提供的其他服务。同时，您有权对美滋来外卖平台上的商家服务做出评价和投诉，并提出建议和意见。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >3.3您理解并同意，<strong
            ><u
              >美滋来外卖为您与商家进行外卖交易提供网络交易平台服务，美滋来外卖属于独立的第三方平台，并非用户所购的商品或服务的交易相对方。您在进行外卖交易的过程中所产生的相关税费以及有关硬件、软件、服务及其他方面的费用将由您或商家、配送服务提供方或其他商品/服务提供方依据相关合同或法律规定予以承担，美滋来外卖不承担缴纳与您的外卖交易有关的任何税费及代为开具发票等义务。</u
            ></strong
          ></span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >3.4<strong
            ><u
              >美滋来外卖将根据《中华人民共和国电子商务法》等法律法规要求，对平台商家予以审慎审核（包括但不限于证照审核等），并记录、保存平台上发布的商品和服务信息、交易信息，以积极保障您的人身、财产安全，但鉴于平台存在海量信息及客观上信息与实物相分离的特点，美滋来外卖客观上无法逐一实质审查每一商品/服务的信息，除法律法规强制性规定外，美滋来外卖不对平台上的任何第三方所销售的产品或服务的真实性、适用性、合法性、安全性提供任何形式的明示或默示的担保、声明或承诺，亦不对因此所导致的您的任何损失（含第三方侵权行为给您造成的损害）承担任何责任，但美滋来外卖在其中存在故意或重大过失的除外。如您在使用外卖交易服务的过程中发现平台中的相关产品或服务信息违反法律规定，您可及时向美滋来外卖或有关机关举报或投诉，美滋来外卖将在收到您的举报或投诉时采取相应的核实与处理措施。</u
            ></strong
          ></span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p>
        <span style="color: #000000"
          >3.5&nbsp;<strong
            ><u
              >您知悉、理解并同意，美滋来外卖服务过程中，可能涉及收集、存储、使用、共享和保护用户个人信息。在您使用美滋来外卖提供的服务时，您同意美滋来外卖依据《美滋来外卖平台隐私政策》（链接地址：https://cer.mulazim.com/Privacy_policy）的规定执行相关个人信息的收集、使用和共享。您进一步同意，就美滋来外卖平台所产生的外卖交易，您授权美滋来外卖使用或允许美滋来外卖审核许可的第三方在必要、合理的限度内使用您的个人信息，包括但不限于身份信息、账户信息、交易信息等。</u
            ></strong
          ></span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >3.6&nbsp;您理解并同意：<strong
            ><u
              >为向您提供更为细致、贴心的服务，美滋来外卖或美滋来外卖授权的商家将向您发送与美滋来外卖网站管理、服务规则更新、或您可能感兴趣的外卖信息（包括但不限于商家促销、优惠券、产品更新等产品或服务相关信息）相关的电子邮件、站内信和/或手机短消息，其方式和范围可不经向您特别通知而变更。您有权选择是否退订美滋来外卖发送的关于外卖信息的电子邮件、站内信和/或短信息。</u
            ></strong
          ></span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: left; text-indent: 2em" class="MsoNormal">
        <strong
          ><span style="color: #000000">四、&nbsp;外卖交易规则</span></strong
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >您通过美滋来外卖进行交易时，应当遵守本条款、《美滋来外卖平台用户服务协议》及各项服务规则。具体而言，您承诺在通过美滋来外卖进行外卖交易的过程中遵守如下规则：</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000">4.1&nbsp;浏览外卖信息</span>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >您在美滋来外卖上浏览外卖商品/服务的外卖信息时，应当仔细阅读外卖信息中包含的全部内容，包括但不限于外卖商品/服务的名称、种类、数量、质量、商品价格/服务、包装费（包含但不限于餐盒费和外包装塑料袋等餐品全部包装费用）、有效期、预计送达时间、商家地址、营业时间、配送方式等内容，其中您应特别注意外卖商品/服务的有效期、美滋来红包和商家代金券使用条件等内容，您应在认真阅读、理解并完全接受外卖信息中所包含的全部内容后方可点击购买（或“下单”等类似功能按键，下同）。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000">4.2&nbsp;提交及确认外卖订单</span>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.2.1&nbsp;您在点击购买后，将进入外卖订单页面（具体页面内容及标题可能因网页或客户端版本不同，在不同时期而有所差异）。您应当仔细阅读外卖订单页面中所包含的全部内容，包括但不限于上述外卖信息中的全部内容、为再次提示您注意而标明的本单外卖商品/服务的有效期、退款条件等内容（如有），选择及确认购买数量、价格、应付总额、用户接收外卖电子消费凭证的联系方式或接收货物的收货地址和送货时间等内容。<strong
            ><u
              >前述外卖订单页面中所包含的全部内容，构成了用户与商家之间达成的外卖合同的合同内容，将视为商家的要约，您在完全同意外卖订单的全部内容后方可提交订单。</u
            ></strong
          >您需配合提供最新、真实、完整、有效的信息，以使外卖订单及时准确的完成。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.2.2&nbsp;美滋来外卖特别提示您：<strong
            ><u
              >您在提交订单前应再次阅读并确认外卖订单的全部内容后方可点击确认订单并付款，您提交订单即视为您已知晓、同意并接受外卖订单中的全部内容，与商家、配送服务商（如适用）成立了外卖合同。外卖订单中所包含的全部内容即为外卖合同的内容，包括但不限于外卖商品/服务的名称、种类、数量、质量、价格、有效期、商家地址、营业时间、配送方式等，您与商家均应当按照前述外卖合同的约定履行各自的权利义务。</u
            ></strong
          ></span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000">4.3&nbsp;支付外卖价款</span>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >在外卖合同成立之后，您应根据付款页面的提示通过美滋来外卖的网上支付平台完成外卖价款的支付。因美滋来外卖接受商家委托代商家向您收取外卖价款，故您通过美滋来外卖平台成功支付价款即视为您已向商家履行了外卖合同项下的外卖价款支付义务。您在支付外卖价款之前不得要求商家向您提供外卖商品/服务，美滋来外卖在特定商品或服务页面中特别明示说明的除外。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000">4.4&nbsp;配送服务</span>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.4.1您知悉、理解并同意：“预计送达时间”是系统根据商家距离、商品/服务准备时间、用户评价的时间等因素进行自动综合计算而得到的参考时间，商家的实际配送时间会受到当天的天气、订单量等多种外界因素影响而有所差异。您理解并同意，<strong
            ><u
              >预计送达时间不作为美滋来外卖或商家对您做出的配送到达时间的承诺。您可根据需要，自行选择购买美滋来外卖提供的配送延误保障服务（如适用），以更好地保障外卖配送的时效性或获得相应的补偿。</u
            ></strong
          ></span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.4.2您理解并同意，在外卖合同成立且您已付款的情况下，商家或第三方配送服务商将负责完成餐品配送服务，配送服务费用（如有）的具体金额以您已确认及提交的订单上所的显示金额为准，您知悉并授权第三方配送服务商（如适用）向商家取货并将商品送到您所指定的收货地址，并同意通过美滋来外卖平台支付相关配送服务商的配送费用（如有）。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000">4.5&nbsp;退款规则</span>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >为了使您在使用美滋来外卖网上订餐服务中有更好的体验，美滋来外卖平台特制定退款规则，以供各方遵守。您成功支付外卖价款后，如需要进行退款的，将按照如下规则进行：</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.5.1&nbsp;取消订单原则：如果商家尚未接单，您可以在订单详情页通过“取消订单”功能进行取消；如果商家已确认接单，则您需要自行电话联系商家后由商家取消订单。<strong
            ><u
              >您知悉、理解并同意：如商家因已出餐等合理原因不同意您取消订单的，则您将不能取消该笔订单或拒收餐品；如您坚持取消订单或拒收餐品，则餐品相关费用与损失将由您全部承担，相关损失将会视实际情况由商家在您支付的外卖价款中予以部分或全额扣除。此外，如取消的订单中附有赠送商品、代金券或附赠服务且该商品或服务已消费或无法退还商家，则赠送商品、代金券或附赠服务的价值金额应首先从退款中予以扣除。您理解并同意，取消订单成功后，您与商家间的外卖合同即宣告解除。</u
            ></strong
          ></span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.5.2&nbsp;发生以下情形之一的，外卖合同解除，您有权要求美滋来外卖代相应商家进行退款：</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >(1)您通过美滋来外卖付款成功后，因不可抗力或不可归责于商家的原因，导致商家无法向您提供外卖商品/服务，经美滋来外卖核实后属实的；&nbsp;</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >(2)您通过美滋来外卖付款成功后，确因客观情况变化、页面信息显示错误、系统故障、物料短缺等特殊原因导致商家需要合理变更外卖合同内容，您不接受变更后的内容的。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.5.3&nbsp;您知悉、理解并同意：因餐饮行业消费特殊性，如您在商家已确认接单或已出餐后，要求商家退款或要求美滋来外卖代商家进行退款的，商家及/或美滋来外卖有权拒绝，但下述情形除外：</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >(1)外卖商品/服务与外卖订单约定内容严重不符；&nbsp;</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >(2)在交付给您之前，餐品外包装损坏严重导致餐品在数量、质量上严重不符合外卖订单约定；&nbsp;</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >(3)存在其他严重质量问题或违反《中华人民共和国食品安全法》、《中华人民共和国食品安全法实施条例》、《餐饮服务食品安全监督管理办法》、《中华人民共和国消费者权益保护法》等法律规定的强制性、禁止性规定的情况。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.5.4&nbsp;符合美滋来外卖关于退款规定的，您可以向美滋来外卖申请退款。经美滋来外卖审核确认后，美滋来外卖将于7个工作日内将款项按照您的支付路径原路退回至您的支付账户。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.5.5&nbsp;其他情形下的退款（如适用）将按照外卖合同内容约定的退款条件及退款方式进行。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.5.6&nbsp;在退款进行过程中，您应当遵守美滋来外卖关于退款的相关服务规则的规定。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.5.7&nbsp;您确认，除法律法规另有强制性规定外，下列性质的商品不适用七日无理由退货规定：</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >（一）拆封后易影响人身安全或者生命健康的商品，或者拆封后易导致商品品质发生改变的商品，例如食品等。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >（二）一经激活或者试用后价值贬损较大的商品；</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >（三）销售时已明示的临近保质期的或有其他瑕疵的商品；</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >（四）法律、法规明确规定及美滋来外卖发布的其他规则规定不适用七日无理由退货规定的其他商品。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000">4.6&nbsp;用户评价</span>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.6.1您有权在美滋来外卖提供的评价系统中对通过美滋来外卖与您达成交易的商品/服务进行评价。您知晓并同意，您在美滋来外卖的评价信息是公开的，如您不愿意在评价信息中向公众披露本人的身份信息，您有权选择通过匿名形式发表评价。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.6.2您的评价行为应遵守法律法规、《美滋来外卖用户评价规则》及美滋来外卖因管理需要所制定的相关规则。评价内容应当客观真实，不应包含任何污言秽语、色情低俗、广告、不正当竞争等法律法规与本条款及/或美滋来外卖其他规则所列明的其他禁止性信息。&nbsp;</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.6.3您不得以“刷单”等不正当方式帮助商家提升信用，或利用评价权利对其他商家或用户进行恶意评价，或实施威胁、敲诈勒索或法律法规与本条款及/或美滋来外卖其他服务规则列明的其他禁止性行为，否则美滋来外卖可依据情况对您采取禁止/屏蔽评价资格、剥夺优惠资格、网站上公布违法行为、封禁注销账号等处罚措施，必要时将保留向您追究民事、刑事等法律责任的权利。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.6.4&nbsp;您违反法律法规或者本条款及/或美滋来外卖其他服务规则之禁止性规定，发布违法、侵权、违规评价信息的，应当自行承担法律责任。因此给美滋来外卖造成损失的，您应负责全部赔偿责任，包括且不限于财产损害赔偿、名誉损害赔偿、诉讼费、律师费、公证费、交通费等因维权而产生的合理费用。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000">4.7参与活动</span>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.7.1您应当按照美滋来外卖发布的相关服务规则参加美滋来外卖抽奖等美滋来外卖组织的活动，并遵守活动秩序，任何以刷单、外挂、作弊、扰乱系统、实施网络攻击、恶意套现、刷信誉、批量注册账号、用机器模拟客户端等手段骗取奖品或参加其他美滋来外卖平台所组织的活动的，美滋来外卖将保留取消奖励或参加活动资格、封禁注销账号、向主管机关举报并向您进一步追究民事、刑事等法律责任的权利。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.7.2您在使用美滋来红包和商家代金券时应遵守美滋来外卖发布的包括《美滋来红包使用规则》、《美滋来外卖代金券使用规则》在内的各项服务规则。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000">4.8用户不正当行为及责任</span>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.8.1&nbsp;为维护正常用户的合法权益，您在遵守《美滋来外卖平台用户服务协议》的基础之上，进一步承诺不会独自和/或伙同他人（包括美滋来外卖平台的商家）实施虚假、欺诈、破坏、不诚信行为，包括但不限于：</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000">(1)批量注册美滋来外卖账号；&nbsp;</span>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >(2)无正当理由批量购买后批量申请退款；&nbsp;</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >(3)虚假交易（如提交订单后并未产生真实交易，无论用户是否因此获利）；&nbsp;</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000">(4)虚假分享；&nbsp;</span>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000">(5)虚假或恶意评论；&nbsp;</span>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >(6)填写错误送餐地址、留存错误的收餐电话、拒绝接听送餐员电话、无正当理由拒收餐品或餐品在合理时间内送达订单载明收货地址后10分钟内无法联系到您或您无正当理由拒收餐品等；&nbsp;</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >(7)发布炒作信用为目的的信息、与网上订餐交易无关或不以订餐为目的的信息；</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >(8)恶意干扰正常外卖交易秩序，或其他违反诚实信用原则或损害美滋来外卖、用户、商家或其他第三方合法利益的行为。&nbsp;</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >如发现您有上述行为，美滋来外卖有权终止订单，且不予退款。如您尚未付款，美滋来外卖有权向您追偿订单费用及其他损失，同时对于您的账户采取包括但不限于删除违法信息、禁止/屏蔽评价资格、剥夺优惠资格、网站上公布违法行为、封禁注销账号等处罚措施，必要时将保留向您追究民事、刑事等法律责任的权利。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >4.8.2&nbsp;您违反本条款、《美滋来外卖平台用户服务协议》或美滋来外卖不时发布的任何服务规则，包括但不限于虚假交易、虚假投诉、从事非法活动等给美滋来外卖、商家或其他第三方造成损失的，您应负全部赔偿责任，包括且不限于财产损害赔偿、名誉损害赔偿、诉讼费、律师费、公证费、交通费等因维权而产生的合理费用。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: left; text-indent: 2em" class="MsoNormal">
        <strong><span style="color: #000000">五、&nbsp;知识产权</span></strong>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >5.1美滋来外卖所展示的包含网上订餐系统在内的各运营系统由美滋来外卖自主开发、运营提供技术支持，并对美滋来外卖服务的开发和运营等过程中产生的所有数据和信息等享有全部权利。美滋来外卖提供各项服务时所依托软件的著作权、专利权，所使用的各项商标、商业形象、商业标识、技术诀窍，其著作权、商标权及其他各项相关权利均归美滋来外卖所有。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >5.2您理解并同意：<strong
            ><u
              >您在美滋来外卖平台发表的产品使用体验、产品讨论或图片等所有信息（以下简称“信息”）及其衍生品的知识产权及所有权，适用《美滋来外卖平台用户服务协议》中的相关约定</u
            ></strong
          >。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: left; text-indent: 2em" class="MsoNormal">
        <strong><span style="color: #000000">六、&nbsp;争议解决</span></strong>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >6.1<strong
            ><u
              >&nbsp;如您与商家因外卖合同的履行发生任何争议，包括但不限于对外卖商品/服务的数量、质量、价格、有效期、商家地址、配送方式、退换货方式、退款条件、售后服务等问题发生争议的，您应与商家根据外卖合同内容的约定确定双方各自的权利义务、承担各自的责任，解决争议。美滋来外卖可在法律法规要求的范围内协助您与商家之间争议的协商调解。您同意，美滋来外卖有权通过电话或电子邮件等方式向争议双方了解情况，并将所了解的情况通过必要方式通知对方。此外，您有权通过司法或执法机关要求美滋来外卖提供相关资料，但您理解并同意，美滋来外卖无任何义务对您与商家之间的任何争议承担任何责任。</u
            ></strong
          ></span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >6.2&nbsp;若您发现商家在提供商品或服务时损害了您的合法权益，您有权依据《中华人民共和国消费者权益保护法》及相关法律、法规的规定向该商家主张并维护自己的合法权益。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >6.3&nbsp;若您与美滋来外卖因本条款内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向本条款签订地（新疆乌鲁木齐市）有管辖权的人民法院提起诉讼。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >6.4&nbsp;因您使用美滋来外卖服务而引起或与之相关的一切争议、权利主张或其它事项，均适用中华人民共和国大陆地区法律，并且排除一切冲突法规定的适用。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: left; text-indent: 2em" class="MsoNormal">
        <strong><span style="color: #000000">七、&nbsp;环保倡议</span></strong>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >美滋来外卖重视绿色环保，倡导绿色消费。提倡您保护环境，尽量减少一次性餐具的使用，按照实际需求在订单页面设置所需餐具数量。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000"
          >如您对本服务协议有任何问题或建议，请在工作时间联系美滋来外卖客服部门（电话：0991-8888380）。</span
        >
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal">
        <span style="color: #000000">再次感谢您的耐心阅读！</span>
      </p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
      <p style="text-align: justify; text-indent: 2em" class="MsoNormal"></p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
    };
  },
  created() {
    this.title = this.$route.query.data;
  },
  methods: {},
};
</script>
